var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurfboardAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.387 4.98595C11.6525 4.76133 11.9327 4.55202 12.2249 4.35645L15.0285 16.381C14.1229 17.1091 13.1526 17.8198 12.1435 18.4862L9.4303 6.84954C10.0907 6.15308 10.7487 5.52591 11.387 4.98595Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32573 8.07678C5.76471 11.0685 3.32256 14.9521 2.04846 18.6427C1.88794 19.1075 2.14026 19.6077 2.59773 19.7691L3.73756 20.1711L4.1149 21.3722C4.26211 21.8398 4.74516 22.1086 5.20487 21.9581C7.10855 21.3356 9.06698 20.3828 10.9319 19.2531L8.32573 8.07678Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1913 15.4055L13.4501 3.64735C16.979 1.88108 21.3551 1.76981 21.7994 2.23291C22.3369 2.79307 21.9341 9.24333 18.8537 12.7682C18.1043 13.6258 17.202 14.5202 16.1913 15.4055Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurfboardAlt);
export default __webpack_public_path__ + "static/media/surfboard-alt.6b8c444e61ab79609b32e8f41b433cc6.svg";
export { ForwardRef as ReactComponent };